export enum ActionPlanStatus {
  open = 'open',
  complete = 'complete',
  awaitingApproval = 'awaitingApproval',
  rejected = 'rejected',
}

export enum ActionPlanAction {
  submit = 'submit',
  reject = 'reject',
  accept = 'accept',
  save = 'save',
}
